import React from 'react';

export const VerifiedUser = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    viewBox="0 96 960 960"
    width="48"
    {...props}
  >
    <path
      className="userverified-icon-path"
      d="m436 709 228-228-42-41-183 183-101-101-44 44 142 143Zm44 266q-140-35-230-162.5T160 533V295l320-120 320 120v238q0 152-90 279.5T480 975Zm0-62q115-38 187.5-143.5T740 533V337l-260-98-260 98v196q0 131 72.5 236.5T480 913Zm0-337Z"
      fill="#2F1359"
    />
  </svg>
);
